import { gql } from "@apollo/client"


export const CREATE_PREORDER_LOGICTICS = gql `
mutation ConfirmPreOrderDelivery($where: OrderDeliveryWhereInput!, $data: OrderDeliveryInput!) {
    confirmPreOrderDelivery(where: $where, data: $data) {
      message
    }
  }
`
/**
 * Deliver the rendered waybill to the customer's Messenger inbox.
 *
 * imageUrl must be the PUBLIC S3 url (the presigned PUT url with its query string
 * stripped) — Meta fetches it server-side, so a presigned GET would expire.
 */
export const SEND_LOGISTIC_BILL_IMAGE = gql`
  mutation SendLogisticBillImage($orderGroupId: ID!, $imageUrl: String!) {
    sendLogisticBillImage(orderGroupId: $orderGroupId, imageUrl: $imageUrl) {
      error
      message
    }
  }
`;
